import { FormUISchema } from "../../../components/JsonForm";
import { AVAILABLE_CABINET_TYPES } from "../../../enums/cabinetTypes";
import { getCabinetName } from "../../Cabinets/CabinetsInfo/CabinetInfoPage.mapper";
import { newCabinetFormSchema } from "./new-cabinet-form-schema";

export const newCabinetUiSchema: FormUISchema<typeof newCabinetFormSchema> = {
  type: "VerticalLayout",
  elements: [
    {
      type: 'LayoutHeader',
      text: 'Идентификация ссылки',
      icon: 'hash-tag',
    },
    {
      type: 'HorizontalLayout',
      elements: [
        {
          type: "Control",
          label: "Идентификатор",
          scope: "#/properties/cabinetIdentifier",
          options: {
            columns: 4,
            icon: 'hash-tag'
          },
        }
      ]
    },
    {
      type: 'LayoutHeader',
      text: 'Основная информация',
      icon: 'user-plus'
    },
    {
      type: "HorizontalLayout",
      elements: [
        {
          type: "Control",
          label: "Банк",
          scope: "#/properties/bank",
          options: {
            enumValueToLabelMap: AVAILABLE_CABINET_TYPES.reduce((res, type) => ({ ...res, [type]: getCabinetName(type)}), {}),
            columns: 2,
            icon: 'bank'
          },
        },
        { type: "Control", label: "Логин", scope: "#/properties/credentials/properties/login", options: { icon: 'user' } },
        { type: "Control", label: "Пароль", scope: "#/properties/credentials/properties/password", options: { icon: 'lock' } },

        { type: "Control", label: "ФИО", scope: "#/properties/baseInfo/properties/name", options: { columns: 2, icon: 'user-plus' } },
        { type: "Control", label: "Дата рождения", scope: "#/properties/baseInfo/properties/birthDate", options: { placeholder: 'ДД-ММ-ГГГГ', icon: 'calendar' } },
        { type: "Control", label: "Телефон", scope: "#/properties/baseInfo/properties/phone", options: { icon: 'phone' } },
      ],
    },

    {
      type: 'LayoutHeader',
      text: 'Паспортные данные',
      icon: 'file-text',
    },
    {
      type: "HorizontalLayout",
      elements: [
        { type: "Control", label: "Серия", scope: "#/properties/passport/properties/series", options: { icon: 'hash-tag' } },
        { type: "Control", label: "Номер", scope: "#/properties/passport/properties/number", options: { icon: 'hash-tag' } },
        { type: "Control", label: "Дата выдачи", scope: "#/properties/passport/properties/issued", options: { placeholder: 'ДД-ММ-ГГГГ', icon: 'calendar' } },
        { type: "Control", label: "Срок действия", scope: "#/properties/passport/properties/validityPeriod", options: { placeholder: 'ДД-ММ-ГГГГ', icon: 'calendar' } },
        { type: "Control", label: "Орган выдачи", scope: "#/properties/passport/properties/issuingAuthority", options: { columns: 3, icon: 'home' } },
        { type: "Control", label: "Код подразделения", scope: "#/properties/passport/properties/departmentCode", options: { placeholder: "000-000", icon: 'hash-tag' }  },
        { type: "Control", label: "Адрес регистрации", scope: "#/properties/passport/properties/registrationAddress", options: { columns: 2, icon: 'point' } },
        { type: "Control", label: "Фактический адрес", scope: "#/properties/passport/properties/address", options: { columns: 2, icon: 'home' } },
      ]
    },

    {
      type: 'LayoutHeader',
      text: 'Обратная связь',
      icon: 'phone',
    },
    {
      type: "HorizontalLayout",
      elements: [
        { type: "Control", label: "Телефон для обратной связи", scope: "#/properties/feedback/properties/phoneNumber",
          options: {
            columns: 3,
            icon: 'phone-in'
          },
        },
        { type: "Control", label: "Тип связи", scope: "#/properties/feedback/properties/phoneType",
          options: {
            enumValueToLabelMap: {
              phone: 'Сотовая связь',
              whatsApp: 'WhatsApp'
            },
            icon: 'message'
          },
        },
      ]
    },

    {
      type: 'LayoutHeader',
      text: 'Настройки чата',
      icon: 'message',
    },
    {
      type: "HorizontalLayout",
      elements: [
        { type: "Control", label: "Сообщение по умолчанию", scope: "#/properties/chat/properties/defaultMessage",
          options: {
            type: 'multiline',
            columns: 3,
            icon: 'message'
          },
        },
        { type: "Control", label: "Автооткрытие чата", scope: "#/properties/chat/properties/autoOpen",
          options: {
            enumValueToLabelMap: {
              on: 'Включено',
              off: 'Выключено'
            },
            icon: 'switch',
          },
        },
      ]
    },

    {
      type: 'LayoutHeader',
      text: 'Баланс пользователя',
      icon: 'card',
    },
    {
      type: "HorizontalLayout",
      elements: [
        { type: "Control", label: "Общий баланс", scope: "#/properties/balance/properties/value",
          options: {
            type: 'multiline',
            columns: 3,
            icon: 'dollar'
          },
        },
        { type: "Control", label: "Валюта общего баланса", scope: "#/properties/balance/properties/currency",
          options: {
            enumValueToLabelMap: {
              rub: '₽',
              usd: '$',
              eur: '€',
            },
            icon: 'hash-tag'
          },
        },
      ]
    },
  ]
}
